import React from "react";

function Footer() {
    return (
        <footer id="dosislite-footer">
            <div className="main-footer">
                <div className="container">
                    <div className="logo-footer">
                        <h2 className="text-logo">Artsenpraktijk Waarloos</h2>
                    </div>
                    <div className="copyright">
                        015 - 31 19 59 | Grote Steenweg 47, 2550 Waarloos
                    </div>
                    <div className="footer-social dosislite-social">

                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer